import(/* webpackMode: "eager" */ "/layers/google.nodejs.yarn/yarn_modules/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/layers/google.nodejs.yarn/yarn_modules/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/workspace/components/Clients.tsx");
import(/* webpackMode: "eager" */ "/workspace/components/CurrencyPrice.tsx");
import(/* webpackMode: "eager" */ "/workspace/components/slider/CardSlider.tsx");
import(/* webpackMode: "eager" */ "/workspace/components/ui/carousel.tsx")